import { render, staticRenderFns } from "./sc.vue?vue&type=template&id=b2664c20&scoped=true&lang=pug&"
import script from "./sc.vue?vue&type=script&lang=js&"
export * from "./sc.vue?vue&type=script&lang=js&"
import style0 from "./sc.vue?vue&type=style&index=0&id=b2664c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2664c20",
  null
  
)

export default component.exports